export const TIER_ZERO_ID = 'tier-0';

export function isTierZero(tierId: string | null | undefined): boolean {
  return tierId === TIER_ZERO_ID;
}
